export default __webpack_public_path__ + "static/media/Beautiful_inner_view_of_Jahangir_Mahal_Orchha_Madhya_Pradesh.cd7b1835.jpg";